export type LineResultValue =
  | 'Not Entered'
  | 'Win'
  | 'Loss'
  | 'Default by Opponent'
  | 'Default by Us'
  | 'Retired Win'
  | 'Retired Loss'
  | 'Double Default';

export type TeamResultValue = 'Win' | 'Loss' | 'Tie' | 'Unknown';

export function scoreLineResult(value: LineResultValue): 0 | 1 | -1 {
  if (value === 'Win' || value === 'Default by Opponent' || value === 'Retired Win') return 1;
  if (value === 'Loss' || value === 'Default by Us' || value === 'Retired Loss') return -1;
  return 0;
}

export function legacyLineResult(value: LineResultValue): 'win' | 'loss' | 'tie' | 'unfinished' | 'defaulted' {
  if (value === 'Win' || value === 'Default by Opponent' || value === 'Retired Win') return 'win';
  if (value === 'Loss' || value === 'Default by Us' || value === 'Retired Loss') return 'loss';
  if (value === 'Double Default') return 'tie';
  return 'unfinished';
}

export function isPlayedLineResult(value: LineResultValue): boolean {
  return !['Not Entered', 'Default by Opponent', 'Default by Us'].includes(value);
}
